import { useField } from 'formik';
import { Grid } from '@mui/material';
import type { SwitchFieldProps } from 'components/fields/switch';

import { InputField, SwitchField } from 'components';

export const OtherOptionRow = ({
  name,
  onChange,
  allowReferenceCodes,
}: {
  name: string;
  allowReferenceCodes: boolean;
  onChange?: SwitchFieldProps['onChange'];
}) => {
  const [, { value: allowOther }] = useField<boolean | undefined>(
    `${name}.options.allowOther`
  );

  const [, , { setValue: setOtherAnswerValue }] = useField<string | undefined>(
    `${name}.options.otherAnswerValue`
  );

  const [, { value: options = [] }] = useField<string[]>(
    `${name}.options.options`
  );

  return (
    <Grid container spacing={2} className="items-center">
      <Grid size={{ md: 4, xs: 6 }}>
        <SwitchField
          label="Allow Other"
          name={`${name}.options.allowOther`}
          onChange={(event, checked) => {
            if (!checked) {
              setOtherAnswerValue(undefined);
            }
            onChange?.(event, checked);
          }}
        />
      </Grid>
      {allowOther && allowReferenceCodes && (
        <Grid size={{ md: 4, xs: 6 }}>
          <InputField
            fullWidth
            label="Value"
            placeholder={String(options.length + 1)}
            name={`${name}.options.otherAnswerValue`}
            slotProps={{ inputLabel: { shrink: true } }}
          />
        </Grid>
      )}
    </Grid>
  );
};
